
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/check/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-check-demo-base","pages-pages-reference-check-demo-validator","pages-pages-reference-check-demo-asyncvalidator"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/check/index.md?type=demo')
};